const materialTestingData = [
  // Rigid Materials
  {
    Material: "PPS-CF",
    MaterialClass: "Aromatic Sulfide",
    Brand: "Polymaker",
    Color: "Black",
    HotendTemp: "350/345",
    BedTemp: "85/80",
    ChamberTemp: "Passive",
    X_Axis_Peak_Load: 296.93,
    X_Axis_Yield_Point: null,
    X_Axis_Break_Point: null,
    Layer_Break: 52.85,
    Direct_Thread_Yield: 68.45,
    Heat_Set_Yield: 123.15,
    Izod_Shock_Break: 23.83,
    Notes: "As Printed",
    color: "#3366CC",
    Shore_Hardness: null,
    Layer_Peak: null,
    Flexible_Layer_Break: null,
    Dist_Break: null,
    Bounce: null,
    Six_mm_Pull: null,
    Sixty_mm_Stretch: null,
    Sixty_mm_Peak: null,
  },
  {
    Material: "PPS-CF",
    MaterialClass: "Aromatic Sulfide",
    Brand: "Polymaker",
    Color: "Black",
    HotendTemp: "350/345",
    BedTemp: "85/80",
    ChamberTemp: "Passive",
    X_Axis_Peak_Load: 304.5,
    X_Axis_Yield_Point: null,
    X_Axis_Break_Point: null,
    Layer_Break: 80.47,
    Direct_Thread_Yield: 72.9,
    Heat_Set_Yield: 106.9,
    Izod_Shock_Break: 22.33,
    Notes: "Annealed 125°C for 16 Hours",
    color: "#5D8AA8",
    Shore_Hardness: null,
    Layer_Peak: null,
    Flexible_Layer_Break: null,
    Dist_Break: null,
    Bounce: null,
    Six_mm_Pull: null,
    Sixty_mm_Stretch: null,
    Sixty_mm_Peak: null,
  },
  {
    Material: "ABS",
    MaterialClass: "Styrene",
    Brand: "Polymaker",
    Color: "Black",
    HotendTemp: "260",
    BedTemp: "105",
    ChamberTemp: "Passive",
    X_Axis_Peak_Load: 166.64,
    X_Axis_Yield_Point: 2.67,
    X_Axis_Break_Point: 3.46,
    Layer_Break: 47.38,
    Direct_Thread_Yield: 44.16,
    Heat_Set_Yield: 95.12,
    Izod_Shock_Break: 50.4,
    Notes: "As Printed",
    color: "#FF9933",
    Shore_Hardness: null,
    Layer_Peak: null,
    Flexible_Layer_Break: null,
    Dist_Break: null,
    Bounce: null,
    Six_mm_Pull: null,
    Sixty_mm_Stretch: null,
    Sixty_mm_Peak: null,
  },
  {
    Material: "ABS",
    MaterialClass: "Styrene",
    Brand: "KVP",
    Color: "Black",
    HotendTemp: "260",
    BedTemp: "105",
    ChamberTemp: "Passive",
    X_Axis_Peak_Load: 140.18,
    X_Axis_Yield_Point: 2.65,
    X_Axis_Break_Point: 3.19,
    Layer_Break: 42.5,
    Direct_Thread_Yield: 65.75,
    Heat_Set_Yield: 40.63,
    Izod_Shock_Break: 52.63,
    Notes: "As Printed",
    color: "#E74C3C",
    Shore_Hardness: null,
    Layer_Peak: null,
    Flexible_Layer_Break: null,
    Dist_Break: null,
    Bounce: null,
    Six_mm_Pull: null,
    Sixty_mm_Stretch: null,
    Sixty_mm_Peak: null,
  },
  {
    Material: "ABS",
    MaterialClass: "Styrene",
    Brand: "Polymaker",
    Color: "White",
    HotendTemp: "260",
    BedTemp: "100",
    ChamberTemp: "Passive",
    X_Axis_Peak_Load: 156.04,
    X_Axis_Yield_Point: 2.74,
    X_Axis_Break_Point: 3.6,
    Layer_Break: 42.5,
    Direct_Thread_Yield: 40.66,
    Heat_Set_Yield: 93.28,
    Izod_Shock_Break: 53.2,
    Notes: "As Printed",
    color: "#F1C40F",
    Shore_Hardness: null,
    Layer_Peak: null,
    Flexible_Layer_Break: null,
    Dist_Break: null,
    Bounce: null,
    Six_mm_Pull: null,
    Sixty_mm_Stretch: null,
    Sixty_mm_Peak: null,
  },
  {
    Material: "ABS",
    MaterialClass: "Styrene",
    Brand: "Polymaker",
    Color: "Natural",
    HotendTemp: "260",
    BedTemp: "100",
    ChamberTemp: "Passive",
    X_Axis_Peak_Load: 173.26,
    X_Axis_Yield_Point: 2.5,
    X_Axis_Break_Point: 3.34,
    Layer_Break: 37.9,
    Direct_Thread_Yield: 42.16,
    Heat_Set_Yield: 91.32,
    Izod_Shock_Break: 55.0,
    Notes: "As Printed",
    color: "#BDC3C7",
    Shore_Hardness: null,
    Layer_Peak: null,
    Flexible_Layer_Break: null,
    Dist_Break: null,
    Bounce: null,
    Six_mm_Pull: null,
    Sixty_mm_Stretch: null,
    Sixty_mm_Peak: null,
  },
  {
    Material: "ASA",
    MaterialClass: "Styrene",
    Brand: "Polymaker",
    Color: "Black",
    HotendTemp: "260",
    BedTemp: "100",
    ChamberTemp: "Passive",
    X_Axis_Peak_Load: 178.3,
    X_Axis_Yield_Point: 3.12,
    X_Axis_Break_Point: 3.69,
    Layer_Break: 83.18,
    Direct_Thread_Yield: 46.7,
    Heat_Set_Yield: 104.7,
    Izod_Shock_Break: 46.4,
    Notes: "As Printed",
    color: "#2C3E50",
    Shore_Hardness: null,
    Layer_Peak: null,
    Flexible_Layer_Break: null,
    Dist_Break: null,
    Bounce: null,
    Six_mm_Pull: null,
    Sixty_mm_Stretch: null,
    Sixty_mm_Peak: null,
  },
  {
    Material: "ASA",
    MaterialClass: "Styrene",
    Brand: "Polymaker",
    Color: "White",
    HotendTemp: "260",
    BedTemp: "100",
    ChamberTemp: "Passive",
    X_Axis_Peak_Load: 172.86,
    X_Axis_Yield_Point: 3.1,
    X_Axis_Break_Point: 3.78,
    Layer_Break: 79.52,
    Direct_Thread_Yield: 34.22,
    Heat_Set_Yield: 92.54,
    Izod_Shock_Break: 47.2,
    Notes: "As Printed",
    color: "#ECEFF1",
    Shore_Hardness: null,
    Layer_Peak: null,
    Flexible_Layer_Break: null,
    Dist_Break: null,
    Bounce: null,
    Six_mm_Pull: null,
    Sixty_mm_Stretch: null,
    Sixty_mm_Peak: null,
  },
  {
    Material: "ASA",
    MaterialClass: "Styrene",
    Brand: "Polymaker",
    Color: "Natural",
    HotendTemp: "260",
    BedTemp: "100",
    ChamberTemp: "Passive",
    X_Axis_Peak_Load: 184.6,
    X_Axis_Yield_Point: 3.38,
    X_Axis_Break_Point: 3.69,
    Layer_Break: 99.7,
    Direct_Thread_Yield: 49.6,
    Heat_Set_Yield: 101.28,
    Izod_Shock_Break: 67.8,
    Notes: "As Printed",
    color: "#F5F5DC",
    Shore_Hardness: null,
    Layer_Peak: null,
    Flexible_Layer_Break: null,
    Dist_Break: null,
    Bounce: null,
    Six_mm_Pull: null,
    Sixty_mm_Stretch: null,
    Sixty_mm_Peak: null,
  },
  {
    Material: "ASA-HP",
    MaterialClass: "Styrene",
    Brand: "Creality",
    Color: "Black",
    HotendTemp: "260",
    BedTemp: "100",
    ChamberTemp: "Passive",
    X_Axis_Peak_Load: 175.82,
    X_Axis_Yield_Point: 4.02,
    X_Axis_Break_Point: 4.69,
    Layer_Break: 41.42,
    Direct_Thread_Yield: 32.06,
    Heat_Set_Yield: 100.84,
    Izod_Shock_Break: 59.0,
    Notes: "As Printed",
    color: "#455A64",
    Shore_Hardness: null,
    Layer_Peak: null,
    Flexible_Layer_Break: null,
    Dist_Break: null,
    Bounce: null,
    Six_mm_Pull: null,
    Sixty_mm_Stretch: null,
    Sixty_mm_Peak: null,
  },
  {
    Material: "ASA",
    MaterialClass: "Styrene",
    Brand: "eSun",
    Color: "Black",
    HotendTemp: "260",
    BedTemp: "100",
    ChamberTemp: "Passive",
    X_Axis_Peak_Load: 163.76,
    X_Axis_Yield_Point: 3.86,
    X_Axis_Break_Point: 4.48,
    Layer_Break: 43.72,
    Direct_Thread_Yield: 38.1,
    Heat_Set_Yield: 95.88,
    Izod_Shock_Break: 71.6,
    Notes: "As Printed",
    color: "#607D8B",
    Shore_Hardness: null,
    Layer_Peak: null,
    Flexible_Layer_Break: null,
    Dist_Break: null,
    Bounce: null,
    Six_mm_Pull: null,
    Sixty_mm_Stretch: null,
    Sixty_mm_Peak: null,
  },
  {
    Material: "ASA-GF",
    MaterialClass: "Styrene",
    Brand: "SIRAYA Tech",
    Color: "Black",
    HotendTemp: "260",
    BedTemp: "100",
    ChamberTemp: "Passive",
    X_Axis_Peak_Load: 193.26,
    X_Axis_Yield_Point: 3.32,
    X_Axis_Break_Point: 3.38,
    Layer_Break: 26.74,
    Direct_Thread_Yield: 38.88,
    Heat_Set_Yield: 94.52,
    Izod_Shock_Break: 27.6,
    Notes: "As Printed",
    color: "#78909C",
    Shore_Hardness: null,
    Layer_Peak: null,
    Flexible_Layer_Break: null,
    Dist_Break: null,
    Bounce: null,
    Six_mm_Pull: null,
    Sixty_mm_Stretch: null,
    Sixty_mm_Peak: null,
  },
  {
    Material: "ABS-GF",
    MaterialClass: "Styrene",
    Brand: "SIRAYA Tech",
    Color: "Black",
    HotendTemp: "260",
    BedTemp: "100",
    ChamberTemp: "Passive",
    X_Axis_Peak_Load: 179.28,
    X_Axis_Yield_Point: 2.62,
    X_Axis_Break_Point: 2.7,
    Layer_Break: 33.04,
    Direct_Thread_Yield: 41.72,
    Heat_Set_Yield: 94.72,
    Izod_Shock_Break: 26.0,
    Notes: "As Printed",
    color: "#90A4AE",
    Shore_Hardness: null,
    Layer_Peak: null,
    Flexible_Layer_Break: null,
    Dist_Break: null,
    Bounce: null,
    Six_mm_Pull: null,
    Sixty_mm_Stretch: null,
    Sixty_mm_Peak: null,
  },
  {
    Material: "PPA",
    MaterialClass: "Semi-Aromatic Polyamide",
    Brand: "SIRAYA Tech",
    Color: "Black",
    HotendTemp: "300",
    BedTemp: "80",
    ChamberTemp: "Passive",
    X_Axis_Peak_Load: 382.54,
    X_Axis_Yield_Point: 4.86,
    X_Axis_Break_Point: 11.76,
    Layer_Break: 211.4,
    Direct_Thread_Yield: 105.66,
    Heat_Set_Yield: 197.16,
    Izod_Shock_Break: 28.2,
    Notes: "Annealed 100°C for 4 Hours",
    color: "#673AB7",
    Shore_Hardness: null,
    Layer_Peak: null,
    Flexible_Layer_Break: null,
    Dist_Break: null,
    Bounce: null,
    Six_mm_Pull: null,
    Sixty_mm_Stretch: null,
    Sixty_mm_Peak: null,
  },
  {
    Material: "PPA - Heated Chamber",
    MaterialClass: "Semi-Aromatic Polyamide",
    Brand: "SIRAYA Tech",
    Color: "Black",
    HotendTemp: "300",
    BedTemp: "80",
    ChamberTemp: "65",
    X_Axis_Peak_Load: 349.12,
    X_Axis_Yield_Point: 3.85,
    X_Axis_Break_Point: 5.17,
    Layer_Break: 219.48,
    Direct_Thread_Yield: 112.00,
    Heat_Set_Yield: 203.77,
    Izod_Shock_Break: 25.00,
    Notes: "Annealed 100°C for 4 Hours (65°C Chamber)",
    color: "#7B1FA2",
    Shore_Hardness: null,
    Layer_Peak: null,
    Flexible_Layer_Break: null,
    Dist_Break: null,
    Bounce: null,
    Six_mm_Pull: null,
    Sixty_mm_Stretch: null,
    Sixty_mm_Peak: null,
  },
  {
    Material: "PPA-CF",
    MaterialClass: "Semi-Aromatic Polyamide",
    Brand: "SIRAYA Tech",
    Color: "Black",
    HotendTemp: "300",
    BedTemp: "80",
    ChamberTemp: "65",
    X_Axis_Peak_Load: 444.80,
    X_Axis_Yield_Point: 3.35,
    X_Axis_Break_Point: 3.38,
    Layer_Break: 93.26,
    Direct_Thread_Yield: 76.33,
    Heat_Set_Yield: 199.80,
    Izod_Shock_Break: 32.80,
    Notes: "Annealed 100°C for 4 Hours",
    color: "#8E24AA",
    Shore_Hardness: null,
    Layer_Peak: null,
    Flexible_Layer_Break: null,
    Dist_Break: null,
    Bounce: null,
    Six_mm_Pull: null,
    Sixty_mm_Stretch: null,
    Sixty_mm_Peak: null,
  },
  {
    Material: "PPA-CF CORE",
    MaterialClass: "Semi-Aromatic Polyamide",
    Brand: "SIRAYA Tech",
    Color: "Black",
    HotendTemp: "300",
    BedTemp: "80",
    ChamberTemp: "65",
    X_Axis_Peak_Load: 499.10,
    X_Axis_Yield_Point: 3.35,
    X_Axis_Break_Point: 3.39,
    Layer_Break: 106.80,
    Direct_Thread_Yield: 92.07,
    Heat_Set_Yield: 235.15,
    Izod_Shock_Break: 31.20,
    Notes: "Annealed 100°C for 4 Hours",
    color: "#9C27B0",
    Shore_Hardness: null,
    Layer_Peak: null,
    Flexible_Layer_Break: null,
    Dist_Break: null,
    Bounce: null,
    Six_mm_Pull: null,
    Sixty_mm_Stretch: null,
    Sixty_mm_Peak: null,
  },
  {
    Material: "ASA-3DXMax",
    MaterialClass: "Styrene",
    Brand: "3DXTech",
    Color: "Black",
    HotendTemp: "260",
    BedTemp: "100",
    ChamberTemp: "Passive",
    X_Axis_Peak_Load: 154.98,
    X_Axis_Yield_Point: 2.91,
    X_Axis_Break_Point: 3.65,
    Layer_Break: 57.00,
    Direct_Thread_Yield: 41.38,
    Heat_Set_Yield: 86.28,
    Izod_Shock_Break: 49.00,
    Notes: "As Printed",
    color: "#9C27B0",
    Shore_Hardness: null,
    Layer_Peak: null,
    Flexible_Layer_Break: null,
    Dist_Break: null,
    Bounce: null,
    Six_mm_Pull: null,
    Sixty_mm_Stretch: null,
    Sixty_mm_Peak: null,
  },
  {
    Material: "ABS-CF",
    MaterialClass: "Styrene",
    Brand: "3DXTech",
    Color: "Black",
    HotendTemp: "260",
    BedTemp: "100",
    ChamberTemp: "Passive",
    X_Axis_Peak_Load: 164.68,
    X_Axis_Yield_Point: 3.25,
    X_Axis_Break_Point: 3.30,
    Layer_Break: 33.64,
    Direct_Thread_Yield: 38.36,
    Heat_Set_Yield: 104.22,
    Izod_Shock_Break: 40.60,
    Notes: "As Printed",
    color: "#536DFE",
    Shore_Hardness: null,
    Layer_Peak: null,
    Flexible_Layer_Break: null,
    Dist_Break: null,
    Bounce: null,
    Six_mm_Pull: null,
    Sixty_mm_Stretch: null,
    Sixty_mm_Peak: null,
  },
  {
    Material: "HT-PLA",
    MaterialClass: "Aliphatic Polyester",
    Brand: "Polymaker",
    Color: "Black",
    HotendTemp: "220",
    BedTemp: "60",
    ChamberTemp: "Passive",
    X_Axis_Peak_Load: 174.64,
    X_Axis_Yield_Point: 2.70,
    X_Axis_Break_Point: 2.92,
    Layer_Break: 44.20,
    Direct_Thread_Yield: 39.56,
    Heat_Set_Yield: 105.98,
    Izod_Shock_Break: 24.60,
    Notes: "As Printed",
    color: "#4CAF50",
    Shore_Hardness: null,
    Layer_Peak: null,
    Flexible_Layer_Break: null,
    Dist_Break: null,
    Bounce: null,
    Six_mm_Pull: null,
    Sixty_mm_Stretch: null,
    Sixty_mm_Peak: null,
  },
  {
    Material: "HT-PLA",
    MaterialClass: "Aliphatic Polyester",
    Brand: "Polymaker",
    Color: "Black",
    HotendTemp: "220",
    BedTemp: "60",
    ChamberTemp: "Passive",
    X_Axis_Peak_Load: 171.44,
    X_Axis_Yield_Point: 2.42,
    X_Axis_Break_Point: 2.45,
    Layer_Break: 35.80,
    Direct_Thread_Yield: 30.00,
    Heat_Set_Yield: 79.66,
    Izod_Shock_Break: 26.00,
    Notes: "Annealed 110°C for 30 Min",
    color: "#66BB6A",
    Shore_Hardness: null,
    Layer_Peak: null,
    Flexible_Layer_Break: null,
    Dist_Break: null,
    Bounce: null,
    Six_mm_Pull: null,
    Sixty_mm_Stretch: null,
    Sixty_mm_Peak: null,
  },
  {
    Material: "HT-PLA-GF",
    MaterialClass: "Aliphatic Polyester",
    Brand: "Polymaker",
    Color: "Black",
    HotendTemp: "220",
    BedTemp: "60",
    ChamberTemp: "Passive",
    X_Axis_Peak_Load: 204.00,
    X_Axis_Yield_Point: 3.41,
    X_Axis_Break_Point: 3.48,
    Layer_Break: 45.28,
    Direct_Thread_Yield: 45.82,
    Heat_Set_Yield: 108.78,
    Izod_Shock_Break: 29.40,
    Notes: "As Printed",
    color: "#8BC34A",
    Shore_Hardness: null,
    Layer_Peak: null,
    Flexible_Layer_Break: null,
    Dist_Break: null,
    Bounce: null,
    Six_mm_Pull: null,
    Sixty_mm_Stretch: null,
    Sixty_mm_Peak: null,
  },
  {
    Material: "HT-PLA-GF",
    MaterialClass: "Aliphatic Polyester",
    Brand: "Polymaker",
    Color: "Black",
    HotendTemp: "220",
    BedTemp: "60",
    ChamberTemp: "Passive",
    X_Axis_Peak_Load: 177.62,
    X_Axis_Yield_Point: 2.08,
    X_Axis_Break_Point: 2.12,
    Layer_Break: 32.75,
    Direct_Thread_Yield: 32.26,
    Heat_Set_Yield: 95.78,
    Izod_Shock_Break: 28.00,
    Notes: "Annealed 110°C for 30 Min",
    color: "#AED581",
    Shore_Hardness: null,
    Layer_Peak: null,
    Flexible_Layer_Break: null,
    Dist_Break: null,
    Bounce: null,
    Six_mm_Pull: null,
    Sixty_mm_Stretch: null,
    Sixty_mm_Peak: null,
  },
  {
    Material: "PLA-Pro",
    MaterialClass: "Aliphatic Polyester",
    Brand: "Polymaker",
    Color: "Black",
    HotendTemp: "220",
    BedTemp: "60",
    ChamberTemp: "Passive",
    X_Axis_Peak_Load: 205.00,
    X_Axis_Yield_Point: 2.48,
    X_Axis_Break_Point: null,
    Layer_Break: 137.20,
    Direct_Thread_Yield: 71.80,
    Heat_Set_Yield: 131.34,
    Izod_Shock_Break: 41.80,
    Notes: "As Printed",
    color: "#2E7D32",
    Shore_Hardness: null,
    Layer_Peak: null,
    Flexible_Layer_Break: null,
    Dist_Break: null,
    Bounce: null,
    Six_mm_Pull: null,
    Sixty_mm_Stretch: null,
    Sixty_mm_Peak: null,
  },
  {
    Material: "PLA",
    MaterialClass: "Aliphatic Polyester",
    Brand: "Polymaker",
    Color: "Black",
    HotendTemp: "220",
    BedTemp: "60",
    ChamberTemp: "Passive",
    X_Axis_Peak_Load: 226.20,
    X_Axis_Yield_Point: 2.65,
    X_Axis_Break_Point: 3.11,
    Layer_Break: 182.58,
    Direct_Thread_Yield: 94.98,
    Heat_Set_Yield: 167.78,
    Izod_Shock_Break: 27.00,
    Notes: "As Printed",
    color: "#388E3C",
    Shore_Hardness: null,
    Layer_Peak: null,
    Flexible_Layer_Break: null,
    Dist_Break: null,
    Bounce: null,
    Six_mm_Pull: null,
    Sixty_mm_Stretch: null,
    Sixty_mm_Peak: null,
  },
  {
    Material: "PLA-MAX",
    MaterialClass: "Aliphatic Polyester",
    Brand: "Polymaker",
    Color: "RED",
    HotendTemp: "220",
    BedTemp: "60",
    ChamberTemp: "Passive",
    X_Axis_Peak_Load: 146.60,
    X_Axis_Yield_Point: 2.70,
    X_Axis_Break_Point: null,
    Layer_Break: 123.50,
    Direct_Thread_Yield: 58.18,
    Heat_Set_Yield: 130.70,
    Izod_Shock_Break: 75.50,
    Notes: "As Printed",
    color: "#D32F2F",
    Shore_Hardness: null,
    Layer_Peak: null,
    Flexible_Layer_Break: null,
    Dist_Break: null,
    Bounce: null,
    Six_mm_Pull: null,
    Sixty_mm_Stretch: null,
    Sixty_mm_Peak: null,
  },
  {
    Material: "ABS",
    MaterialClass: "Styrene",
    Brand: "GreenGate 3D",
    Color: "Natural",
    HotendTemp: "260",
    BedTemp: "100",
    ChamberTemp: "55",
    X_Axis_Peak_Load: 147.42,
    X_Axis_Yield_Point: 3.15,
    X_Axis_Break_Point: 3.92,
    Layer_Break: 54.90,
    Direct_Thread_Yield: 70.38,
    Heat_Set_Yield: 97.30,
    Izod_Shock_Break: 58.80,
    Notes: "As Printed",
    color: "#95A5A6",
    Shore_Hardness: null,
    Layer_Peak: null,
    Flexible_Layer_Break: null,
    Dist_Break: null,
    Bounce: null,
    Six_mm_Pull: null,
    Sixty_mm_Stretch: null,
    Sixty_mm_Peak: null,
  },
  {
    Material: "ASA",
    MaterialClass: "Styrene",
    Brand: "ZYLtech",
    Color: "Black",
    HotendTemp: "260",
    BedTemp: "100",
    ChamberTemp: "Passive",
    X_Axis_Peak_Load: 158.68,
    X_Axis_Yield_Point: 3.17,
    X_Axis_Break_Point: 3.44,
    Layer_Break: 36.92,
    Direct_Thread_Yield: 34.92,
    Heat_Set_Yield: 94.52,
    Izod_Shock_Break: 53.6,
    Notes: "As Printed",
    color: "#37474F",
    Shore_Hardness: null,
    Layer_Peak: null,
    Flexible_Layer_Break: null,
    Dist_Break: null,
    Bounce: null,
    Six_mm_Pull: null,
    Sixty_mm_Stretch: null,
    Sixty_mm_Peak: null,
  },
  {
    Material: "PA6-CF20",
    MaterialClass: "Nylon",
    Brand: "Polymaker",
    Color: "Black",
    HotendTemp: "300/290",
    BedTemp: "80",
    ChamberTemp: "Passive",
    X_Axis_Peak_Load: 324.95,
    X_Axis_Yield_Point: 6.36,
    X_Axis_Break_Point: 7.79,
    Layer_Break: 82.44,
    Direct_Thread_Yield: 37.24,
    Heat_Set_Yield: 77.16,
    Izod_Shock_Break: 38.1,
    Notes: "As Printed",
    color: "#1A237E",
    Shore_Hardness: null,
    Layer_Peak: null,
    Flexible_Layer_Break: null,
    Dist_Break: null,
    Bounce: null,
    Six_mm_Pull: null,
    Sixty_mm_Stretch: null,
    Sixty_mm_Peak: null,
  },
  {
    Material: "PA6-CF20",
    MaterialClass: "Nylon",
    Brand: "Polymaker",
    Color: "Black",
    HotendTemp: "300/290",
    BedTemp: "80",
    ChamberTemp: "Passive",
    X_Axis_Peak_Load: 331.68,
    X_Axis_Yield_Point: 7.06,
    X_Axis_Break_Point: 7.21,
    Layer_Break: 87.74,
    Direct_Thread_Yield: 35.26,
    Heat_Set_Yield: 73.0,
    Izod_Shock_Break: 31.7,
    Notes: "Annealed 100°C for 16 Hours",
    color: "#303F9F",
    Shore_Hardness: null,
    Layer_Peak: null,
    Flexible_Layer_Break: null,
    Dist_Break: null,
    Bounce: null,
    Six_mm_Pull: null,
    Sixty_mm_Stretch: null,
    Sixty_mm_Peak: null,
  },
  {
    Material: "CoPA",
    MaterialClass: "Nylon",
    Brand: "Polymaker",
    Color: "Black",
    HotendTemp: "280",
    BedTemp: "Ambient",
    ChamberTemp: "Passive",
    X_Axis_Peak_Load: 201.02,
    X_Axis_Yield_Point: 4.31,
    X_Axis_Break_Point: null,
    Layer_Break: 55.5,
    Direct_Thread_Yield: 86.0,
    Heat_Set_Yield: 121.5,
    Izod_Shock_Break: 33.0,
    Notes: "As Printed",
    color: "#880E4F",
    Shore_Hardness: null,
    Layer_Peak: null,
    Flexible_Layer_Break: null,
    Dist_Break: null,
    Bounce: null,
    Six_mm_Pull: null,
    Sixty_mm_Stretch: null,
    Sixty_mm_Peak: null,
  },
  {
    Material: "CoPA",
    MaterialClass: "Nylon",
    Brand: "Polymaker",
    Color: "Black",
    HotendTemp: "280",
    BedTemp: "Ambient",
    ChamberTemp: "Passive",
    X_Axis_Peak_Load: 295.32,
    X_Axis_Yield_Point: 5.18,
    X_Axis_Break_Point: 5.6,
    Layer_Break: 48.98,
    Direct_Thread_Yield: 96.3,
    Heat_Set_Yield: 120.48,
    Izod_Shock_Break: 35.4,
    Notes: "Annealed 80°C for 6 Hours",
    color: "#AD1457",
    Shore_Hardness: null,
    Layer_Peak: null,
    Flexible_Layer_Break: null,
    Dist_Break: null,
    Bounce: null,
    Six_mm_Pull: null,
    Sixty_mm_Stretch: null,
    Sixty_mm_Peak: null,
  },
  {
    Material: "PET-CF",
    MaterialClass: "Polyester",
    Brand: "Polymaker",
    Color: "Black",
    HotendTemp: "280",
    BedTemp: "70",
    ChamberTemp: "Passive",
    X_Axis_Peak_Load: 198.6,
    X_Axis_Yield_Point: 3.29,
    X_Axis_Break_Point: 4.23,
    Layer_Break: 87.66,
    Direct_Thread_Yield: 36.85,
    Heat_Set_Yield: 112.98,
    Izod_Shock_Break: 23.5,
    Notes: "As Printed",
    color: "#00796B",
    Shore_Hardness: null,
    Layer_Peak: null,
    Flexible_Layer_Break: null,
    Dist_Break: null,
    Bounce: null,
    Six_mm_Pull: null,
    Sixty_mm_Stretch: null,
    Sixty_mm_Peak: null,
  },
  {
    Material: "PET-CF",
    MaterialClass: "Polyester",
    Brand: "Polymaker",
    Color: "Black",
    HotendTemp: "280",
    BedTemp: "70",
    ChamberTemp: "Passive",
    X_Axis_Peak_Load: 253.16,
    X_Axis_Yield_Point: 2.66,
    X_Axis_Break_Point: 2.7,
    Layer_Break: 63.06,
    Direct_Thread_Yield: 42.74,
    Heat_Set_Yield: 110.68,
    Izod_Shock_Break: 20.25,
    Notes: "Annealed 120°C for 10 Hours",
    color: "#00897B",
    Shore_Hardness: null,
    Layer_Peak: null,
    Flexible_Layer_Break: null,
    Dist_Break: null,
    Bounce: null,
    Six_mm_Pull: null,
    Sixty_mm_Stretch: null,
    Sixty_mm_Peak: null,
  },
  {
    Material: "PET-CF",
    MaterialClass: "Polyester",
    Brand: "SIRAYA Tech",
    Color: "Black",
    HotendTemp: "280",
    BedTemp: "70",
    ChamberTemp: "Passive",
    X_Axis_Peak_Load: 369.78,
    X_Axis_Yield_Point: 3.7,
    X_Axis_Break_Point: 3.74,
    Layer_Break: 89.16,
    Direct_Thread_Yield: 68.9,
    Heat_Set_Yield: 119.62,
    Izod_Shock_Break: 26.6,
    Notes: "As Printed",
    color: "#26A69A",
    Shore_Hardness: null,
    Layer_Peak: null,
    Flexible_Layer_Break: null,
    Dist_Break: null,
    Bounce: null,
    Six_mm_Pull: null,
    Sixty_mm_Stretch: null,
    Sixty_mm_Peak: null,
  },
  {
    Material: "PET-CF",
    MaterialClass: "Polyester",
    Brand: "SIRAYA Tech",
    Color: "Black",
    HotendTemp: "280",
    BedTemp: "70",
    ChamberTemp: "Passive",
    X_Axis_Peak_Load: 352.82,
    X_Axis_Yield_Point: 2.76,
    X_Axis_Break_Point: 2.79,
    Layer_Break: 91.55,
    Direct_Thread_Yield: 74.98,
    Heat_Set_Yield: 124.06,
    Izod_Shock_Break: 22.4,
    Notes: "Annealed 120°C for 10 Hours",
    color: "#4DB6AC",
    Shore_Hardness: null,
    Layer_Peak: null,
    Flexible_Layer_Break: null,
    Dist_Break: null,
    Bounce: null,
    Six_mm_Pull: null,
    Sixty_mm_Stretch: null,
    Sixty_mm_Peak: null,
  },
  {
    Material: "PA612-CF15",
    MaterialClass: "Nylon",
    Brand: "Polymaker",
    Color: "Black",
    HotendTemp: "290.00",
    BedTemp: "80.00",
    ChamberTemp: "Passive",
    X_Axis_Peak_Load: 354.82,
    X_Axis_Yield_Point: 5.42,
    X_Axis_Break_Point: 5.47,
    Layer_Break: 129.34,
    Direct_Thread_Yield: 43.32,
    Heat_Set_Yield: 113.84,
    Izod_Shock_Break: 26.33,
    Notes: "As Printed",
    color: "#0288D1",
    Shore_Hardness: null,
    Layer_Peak: null,
    Flexible_Layer_Break: null,
    Dist_Break: null,
    Bounce: null,
    Six_mm_Pull: null,
    Sixty_mm_Stretch: null,
    Sixty_mm_Peak: null,
  },
  {
    Material: "PA612-CF15",
    MaterialClass: "Nylon",
    Brand: "Polymaker",
    Color: "Black",
    HotendTemp: "290.00",
    BedTemp: "80.00",
    ChamberTemp: "Passive",
    X_Axis_Peak_Load: 389.48,
    X_Axis_Yield_Point: 4.73,
    X_Axis_Break_Point: 4.76,
    Layer_Break: 123.58,
    Direct_Thread_Yield: 51.0,
    Heat_Set_Yield: 122.32,
    Izod_Shock_Break: 29.2,
    Notes: "Annealed 100°C for 16 Hours",
    color: "#039BE5",
    Shore_Hardness: null,
    Layer_Peak: null,
    Flexible_Layer_Break: null,
    Dist_Break: null,
    Bounce: null,
    Six_mm_Pull: null,
    Sixty_mm_Stretch: null,
    Sixty_mm_Peak: null,
  },
  {
    Material: "PETG-rCF17",
    MaterialClass: "Copolyester",
    Brand: "Polymaker",
    Color: "Black",
    HotendTemp: "255.00",
    BedTemp: "70.00",
    ChamberTemp: "Passive",
    X_Axis_Peak_Load: 264.0,
    X_Axis_Yield_Point: 3.26,
    X_Axis_Break_Point: 3.35,
    Layer_Break: 77.72,
    Direct_Thread_Yield: 51.06,
    Heat_Set_Yield: 163.84,
    Izod_Shock_Break: 23.6,
    Notes: "As Printed",
    color: "#7B1FA2",
    Shore_Hardness: null,
    Layer_Peak: null,
    Flexible_Layer_Break: null,
    Dist_Break: null,
    Bounce: null,
    Six_mm_Pull: null,
    Sixty_mm_Stretch: null,
    Sixty_mm_Peak: null,
  },
  {
    Material: "PET-GF15",
    MaterialClass: "Polyester",
    Brand: "Polymaker",
    Color: "Black",
    HotendTemp: "300.00",
    BedTemp: "80.00",
    ChamberTemp: "65",
    X_Axis_Peak_Load: 221.03,
    X_Axis_Yield_Point: 3.34,
    X_Axis_Break_Point: 4.22,
    Layer_Break: 134.20,
    Direct_Thread_Yield: 69.73,
    Heat_Set_Yield: 130.73,
    Izod_Shock_Break: 25.67,
    Notes: "As Printed",
    color: "#37474F",
    Shore_Hardness: null,
    Layer_Peak: null,
    Flexible_Layer_Break: null,
    Dist_Break: null,
    Bounce: null,
    Six_mm_Pull: null,
    Sixty_mm_Stretch: null,
    Sixty_mm_Peak: null,
  },
// --- NEW: PET-GF15 (SirayaTech) ---
{
  Material: "PET-GF15",
  MaterialClass: "Polyester",
  Brand: "SIRAYA Tech",
  Color: "FDE",
  HotendTemp: "300",
  BedTemp: "80",
  ChamberTemp: "65",
  X_Axis_Peak_Load: 294.43,
  X_Axis_Yield_Point: 3.70,
  X_Axis_Break_Point: 3.81,
  Layer_Break: 112.00,
  Direct_Thread_Yield: 80.03,
  Heat_Set_Yield: 172.27,
  Izod_Shock_Break: 25.00,
  Notes: "As Printed",
  color: "#1E88E5", // blue
},

// --- NEW: ABS-CF CORE (SirayaTech) ---
{
  Material: "ABS-CF CORE",
  MaterialClass: "Styrene",
  Brand: "SIRAYA Tech",
  Color: "Black",
  HotendTemp: "280",
  BedTemp: "105",
  ChamberTemp: "65",
  X_Axis_Peak_Load: 270.20,
  X_Axis_Yield_Point: 2.48,
  X_Axis_Break_Point: 2.51,
  Layer_Break: 93.33,
  Direct_Thread_Yield: 39.55,
  Heat_Set_Yield: 134.03,
  Izod_Shock_Break: 28.67,
  Notes: "As Printed",
  color: "#8E24AA", // purple
},

// --- NEW: ABS-CF (SirayaTech) ---
{
  Material: "ABS-CF",
  MaterialClass: "Styrene",
  Brand: "SIRAYA Tech",
  Color: "Black",
  HotendTemp: "270",
  BedTemp: "105",
  ChamberTemp: "65",
  X_Axis_Peak_Load: 210.80,
  X_Axis_Yield_Point: 2.53,
  X_Axis_Break_Point: 2.60,
  Layer_Break: 71.17,
  Direct_Thread_Yield: 57.33,
  Heat_Set_Yield: 122.23,
  Izod_Shock_Break: 26.50,
  Notes: "As Printed",
  color: "#43A047", // green
},
// --- NEW: PA12-CF10 (Polymaker) ---
{
  Material: "PA12-CF10",
  MaterialClass: "Nylon",
  Brand: "Polymaker",
  Color: "Black",
  HotendTemp: "290",
  BedTemp: "80",
  ChamberTemp: "Passive",
  X_Axis_Peak_Load: 335.30,
  X_Axis_Yield_Point: 5.42,
  X_Axis_Break_Point: 5.60,
  Layer_Break: 139.87,
  Direct_Thread_Yield: 50.03,
  Heat_Set_Yield: 97.37,
  Izod_Shock_Break: 43.00,
  Notes: "As Printed",
  color: "#FB8C00", // orange
},
// --- NEW: PC-MAX (Polymaker) ---
{
  Material: "PC-MAX",
  MaterialClass: "Polycarbonate",
  Brand: "Polymaker",
  Color: "Black",
  HotendTemp: "270",
  BedTemp: "100",
  ChamberTemp: "Passive",
  X_Axis_Peak_Load: 236.83,
  X_Axis_Yield_Point: 3.84,
  X_Axis_Break_Point: 4.71,
  Layer_Break: 118.40,
  Direct_Thread_Yield: 69.83,
  Heat_Set_Yield: 108.33,
  Izod_Shock_Break: 98.33,
  Notes: "As Printed",
  color: "#00ACC1", // teal (new class will show as its own group)
},
// --- NEW: PETG (Polymaker) ---
{
  Material: "PETG New Formula OCT2025",
  MaterialClass: "Copolyester",
  Brand: "Polymaker",
  Color: "Black",
  HotendTemp: "250",
  BedTemp: "70",
  ChamberTemp: "Passive",
  X_Axis_Peak_Load: 230.73,
  X_Axis_Yield_Point: 3.98,
  X_Axis_Break_Point: null,   // "NA" in sheet
  Layer_Break: 241.37,
  Direct_Thread_Yield: 83.20,
  Heat_Set_Yield: 146.10,
  Izod_Shock_Break: 0.52,
  Notes: "As Printed",
  color: "#EC407A",            // distinct accent for PETG
},
// --- NEW: PPA-GF (SirayaTech) ---
{
  Material: "PPA-GF",
  MaterialClass: "Semi-Aromatic Polyamide",
  Brand: "SIRAYA Tech",
  Color: "Black",
  HotendTemp: "310",
  BedTemp: "100",
  ChamberTemp: "65",
  X_Axis_Peak_Load: 385.63,
  X_Axis_Yield_Point: 3.37,
  X_Axis_Break_Point: 3.40,
  Layer_Break: 155.67,
  Direct_Thread_Yield: 115.10,
  Heat_Set_Yield: 152.80,
  Izod_Shock_Break: 23.67,
  Notes: "As Printed",
  color: "#5C6BC0", // indigo
},
// --- NEW: PC-CF (YXPOLYER) ---
{
  Material: "PC-CF",
  MaterialClass: "Polycarbonate",
  Brand: "YXPOLYER",
  Color: "Black",
  HotendTemp: "270",
  BedTemp: "100",
  ChamberTemp: "65",
  X_Axis_Peak_Load: 213.53,
  X_Axis_Yield_Point: 3.15,
  X_Axis_Break_Point: 3.31,
  Layer_Break: 64.97,
  Direct_Thread_Yield: 67.23,
  Heat_Set_Yield: 125.30,
  Izod_Shock_Break: 29.33,
  Notes: "As Printed",
  color: "#00897B", // teal
},
// --- NEW: PETG Old Formula (Polymaker) ---
{
  Material: "PETG Old Formula",
  MaterialClass: "Copolyester",
  Brand: "Polymaker",
  Color: "Black",
  HotendTemp: "250",
  BedTemp: "70",
  ChamberTemp: "Passive",
  X_Axis_Peak_Load: 189.93,
  X_Axis_Yield_Point: 3.49,
  X_Axis_Break_Point: 3.63,
  Layer_Break: 106.20,
  Direct_Thread_Yield: 100.80,
  Heat_Set_Yield: 124.87,
  Izod_Shock_Break: 21.67,
  Notes: "As Printed",
  color: "#7E57C2", // distinct purple for easy spotting
},
// --- NEW: Pro PCTG (3D-Fuel) ---
{
  Material: "Pro PCTG Clear",
  MaterialClass: "Copolyester",
  Brand: "3D-Fuel",
  Color: "Clear",
  HotendTemp: "270",
  BedTemp: "80",
  ChamberTemp: "Passive",
  X_Axis_Peak_Load: 186.87,
  X_Axis_Yield_Point: 4.57,
  X_Axis_Break_Point: 4.77,
  Layer_Break: 134.17,
  Direct_Thread_Yield: 63.53,
  Heat_Set_Yield: 96.33,
  Izod_Shock_Break: 24.00,
  Notes: "As Printed",
  color: "#26C6DA", // distinctive cyan
},
// --- NEW: Pro PETG (3D-Fuel) ---
{
  Material: "Pro PETG",
  MaterialClass: "Copolyester",
  Brand: "3D-Fuel",
  Color: "Black",
  HotendTemp: "270",
  BedTemp: "80",
  ChamberTemp: "Passive",
  X_Axis_Peak_Load: 196.80,
  X_Axis_Yield_Point: 4.60,
  X_Axis_Break_Point: null, // "NA"
  Layer_Break: 83.30,
  Direct_Thread_Yield: 54.95,
  Heat_Set_Yield: 106.40,
  Izod_Shock_Break: 23.33,
  Notes: "As Printed",
  color: "#1f3a93",
},
// --- NEW: Tough Pro PLA+ (3D-Fuel) ---
{
  Material: "Tough Pro PLA+",
  MaterialClass: "Aliphatic Polyester",
  Brand: "3D-Fuel",
  Color: "Ocean Blue",
  HotendTemp: "220",
  BedTemp: "65",
  ChamberTemp: "Passive",
  X_Axis_Peak_Load: 215.67,
  X_Axis_Yield_Point: 3.43,
  X_Axis_Break_Point: 3.81,
  Layer_Break: 169.47,
  Direct_Thread_Yield: 111.07,
  Heat_Set_Yield: 131.47,
  Izod_Shock_Break: 36.00,
  Notes: "As Printed",
  color: "#F57C00",            // vivid orange (distinct among PLA family)
},
// --- NEW: PLA+ (3D-Fuel, Charcoal Gray) ---
{
  Material: "PLA+",
  MaterialClass: "Aliphatic Polyester",
  Brand: "3D-Fuel",
  Color: "Charcoal Gray",
  HotendTemp: "220",
  BedTemp: "65",
  ChamberTemp: "Passive",
  X_Axis_Peak_Load: 263.60,
  X_Axis_Yield_Point: 3.49,
  X_Axis_Break_Point: 3.71,
  Layer_Break: 222.33,
  Direct_Thread_Yield: 133.80,
  Heat_Set_Yield: 167.20,
  Izod_Shock_Break: 27.00,
  Notes: "As Printed",
  color: "#00897B",            // deep teal (clear contrast vs orange)
},
// --- NEW: PLA-Pro NEW FORMULA (Polymaker) ---
{
  Material: "PLA-Pro NEW FORMULA",
  MaterialClass: "Aliphatic Polyester",
  Brand: "Polymaker",
  Color: "Black",
  HotendTemp: "220",
  BedTemp: "65",
  ChamberTemp: "Passive",
  X_Axis_Peak_Load: 186.30,
  X_Axis_Yield_Point: 3.03,
  X_Axis_Break_Point: 3.89,
  Layer_Break: 171.33,
  Direct_Thread_Yield: 111.77,
  Heat_Set_Yield: 115.73,
  Izod_Shock_Break: 38.33,
  Notes: "As Printed",
  color: "#7C4DFF",            // distinct purple accent
},

  // --- NEW: ABS (SIRAYA Tech) ---
  {
    Material: "ABS-HT-HF",
    MaterialClass: "Styrene",
    Brand: "SIRAYA Tech",
    Color: "Black",
    HotendTemp: "260",
    BedTemp: "105",
    ChamberTemp: "Passive",
    X_Axis_Peak_Load: 146.60,
    X_Axis_Yield_Point: 2.38,
    X_Axis_Break_Point: 3.74,
    Layer_Break: 104.96,
    Direct_Thread_Yield: 74.83,
    Heat_Set_Yield: 104.825,
    Izod_Shock_Break: 64.75,
    Notes: "As Printed",
    color: "#546E7A",
  },
  {
    Material: "ABS-HT-HF",
    MaterialClass: "Styrene",
    Brand: "SIRAYA Tech",
    Color: "Black",
    HotendTemp: "260",
    BedTemp: "105",
    ChamberTemp: "Passive",
    X_Axis_Peak_Load: 140.27,
    X_Axis_Yield_Point: 2.41,
    X_Axis_Break_Point: 3.74,
    Layer_Break: 98.34,
    Direct_Thread_Yield: 87.33,
    Heat_Set_Yield: 106.95,
    Izod_Shock_Break: 66.75,
    Notes: "Annealed 100°C for 2 Hours",
    color: "#90A4AE",
  },

  // --- NEW: ASA (LDO) ---

  {
    Material: "ASA",
    MaterialClass: "Styrene",
    Brand: "LDO",
    Color: "Olive Green",
    HotendTemp: "260",
    BedTemp: "105",
    ChamberTemp: "65",
    X_Axis_Peak_Load: 143.50,
    X_Axis_Yield_Point: 2.70,
    X_Axis_Break_Point: 3.28,
    Layer_Break: 109.40,
    Direct_Thread_Yield: 52.43,
    Heat_Set_Yield: 95.00,
    Izod_Shock_Break: 1.57,
    HDT: 103.2,
    Notes: "As Printed",
    color: "#6B8E23",
  },

  {
    Material: "ABS",
    MaterialClass: "Styrene",
    Brand: "LDO",
    Color: "Lemon Lime",
    HotendTemp: "260",
    BedTemp: "105",
    ChamberTemp: "65",
    X_Axis_Peak_Load: 158.27,
    X_Axis_Yield_Point: 2.31,
    X_Axis_Break_Point: 2.69,
    Layer_Break: 123.17,
    Direct_Thread_Yield: 65.63,
    Heat_Set_Yield: 91.40,
    Izod_Shock_Break: 0.92,
    HDT: 105.2,
    Notes: "As Printed",
    color: "#C7EA46",
  },
  
  {
    Material: "ASA-CF",
    MaterialClass: "Styrene",
    Brand: "LDO",
    Color: "Black",
    HotendTemp: "260",
    BedTemp: "105",
    ChamberTemp: "65",
    X_Axis_Peak_Load: 165.23,
    X_Axis_Yield_Point: 3.54,
    X_Axis_Break_Point: 3.64,
    Layer_Break: 80.90,
    Direct_Thread_Yield: 47.03,
    Heat_Set_Yield: 90.03,
    Izod_Shock_Break: 0.47,
    HDT: 105.7,
    Notes: "As Printed",
    color: "#3A3A3A",
  },
  
  {
    Material: "ASA",
    MaterialClass: "Styrene",
    Brand: "Sunlu",
    Color: "Black",
    HotendTemp: "260",
    BedTemp: "100",
    ChamberTemp: "65",
    X_Axis_Peak_Load: 177.27,
    X_Axis_Yield_Point: 3.08,
    X_Axis_Break_Point: 3.51,
    Layer_Break: 65.33,
    Direct_Thread_Yield: 50.47,
    Heat_Set_Yield: 107.87,
    Izod_Shock_Break: 0.45,
    HDT: 103.7,
    Notes: "As Printed",
    color: "#1F1F1F",
  },
  
  {
    Material: "ASA",
    MaterialClass: "Styrene",
    Brand: "Flashforge",
    Color: "Black",
    HotendTemp: "260",
    BedTemp: "100",
    ChamberTemp: "65",
    X_Axis_Peak_Load: 160.07,
    X_Axis_Yield_Point: 2.51,
    X_Axis_Break_Point: 3.92,
    Layer_Break: 116.83,
    Direct_Thread_Yield: 46.13,
    Heat_Set_Yield: 113.87,
    Izod_Shock_Break: 0.92,
    HDT: 97.1,
    Notes: "As Printed",
    color: "#4A4A4A",
  },
  
  {
    Material: "ABS",
    MaterialClass: "Styrene",
    Brand: "Jayo",
    Color: "Black",
    HotendTemp: "260",
    BedTemp: "100",
    ChamberTemp: "65",
    X_Axis_Peak_Load: 157.23,
    X_Axis_Yield_Point: 2.55,
    X_Axis_Break_Point: 2.80,
    Layer_Break: 103.27,
    Direct_Thread_Yield: 52.57,
    Heat_Set_Yield: 96.07,
    Izod_Shock_Break: 1.00,
    HDT: 104.8,
    Notes: "As Printed",
    color: "#2C2C2C",
  },
  
  {
    Material: "PLA+",
    MaterialClass: "Aliphatic Polyester",
    Brand: "Jayo",
    Color: "Black",
    HotendTemp: "200",
    BedTemp: "65",
    ChamberTemp: "",
    X_Axis_Peak_Load: 211.10,
    X_Axis_Yield_Point: 2.61,
    X_Axis_Break_Point: 2.91,
    Layer_Break: 188.87,
    Direct_Thread_Yield: 110.13,
    Heat_Set_Yield: 137.67,
    Izod_Shock_Break: 0.98,
    HDT: null,
    Notes: "As Printed",
    color: "#5E35B1",
  },
  
  {
    Material: "PETG",
    MaterialClass: "Copolyester",
    Brand: "Jayo",
    Color: "Black",
    HotendTemp: "235",
    BedTemp: "80",
    ChamberTemp: "",
    X_Axis_Peak_Load: 202.60,
    X_Axis_Yield_Point: 3.22,
    X_Axis_Break_Point: null,
    Layer_Break: 194.87,
    Direct_Thread_Yield: 93.93,
    Heat_Set_Yield: 110.80,
    Izod_Shock_Break: 0.38,
    HDT: 73.6,
    Notes: "As Printed",
    color: "#00897B",
  },
  
  {
    Material: "Pro PCTG Red",
    MaterialClass: "Copolyester",
    Brand: "3D-Fuel",
    Color: "Red",
    HotendTemp: "265",
    BedTemp: "80",
    ChamberTemp: "",
    X_Axis_Peak_Load: 169.83,
    X_Axis_Yield_Point: 4.26,
    X_Axis_Break_Point: null,
    Layer_Break: 106.55,
    Direct_Thread_Yield: 55.37,
    Heat_Set_Yield: 87.20,
    Izod_Shock_Break: 0.57,
    HDT: 81.5,
    Notes: "As Printed",
    color: "#D32F2F",
  },
  
  {
    Material: "PET-CF 285",
    MaterialClass: "Polyester",
    Brand: "3D-Fuel",
    Color: "Black",
    HotendTemp: "285",
    BedTemp: "90",
    ChamberTemp: "65",
    X_Axis_Peak_Load: 221.23,
    X_Axis_Yield_Point: 2.27,
    X_Axis_Break_Point: 2.36,
    Layer_Break: 38.23,
    Direct_Thread_Yield: 57.37,
    Heat_Set_Yield: 115.97,
    Izod_Shock_Break: 0.46,
    HDT: 107.5,
    Min_Bend_Radius: 25,
    Notes: "As Printed",
    color: "#455A64",
  },

  {
  Material: "PET-CF 305 R",
  MaterialClass: "Polyester",
  Brand: "3D-Fuel",
  Color: "Black",
  HotendTemp: "305",
  BedTemp: "105",
  ChamberTemp: "61.5",
  X_Axis_Peak_Load: 283.00,
  X_Axis_Yield_Point: 2.46,
  X_Axis_Break_Point: 2.58,
  Layer_Break: 106.03,
  Direct_Thread_Yield: 63.50,
  Heat_Set_Yield: 127.70,
  Izod_Shock_Break: 0.30,
  Min_Bend_Radius: null,
  HDT: 228.3,
  Notes: "As Printed",
  color: "#263238",
},

{
  Material: "PET-CF 305 A",
  MaterialClass: "Polyester",
  Brand: "3D-Fuel",
  Color: "Black",
  HotendTemp: "305",
  BedTemp: "105",
  ChamberTemp: "61.5",
  X_Axis_Peak_Load: 331.57,
  X_Axis_Yield_Point: 2.47,
  X_Axis_Break_Point: 2.50,
  Layer_Break: 101.10,
  Direct_Thread_Yield: 82.50,
  Heat_Set_Yield: 141.50,
  Izod_Shock_Break: 0.26,
  Min_Bend_Radius: null,
  HDT: 245.0,
  Notes: "Annealed 105° 90 minutes",
  color: "#546E7A",
},

  {
  Material: "PET-GF 305 R",
  MaterialClass: "Polyester",
  Brand: "SIRAYA Tech",
  Color: "FDE",
  HotendTemp: "305",
  BedTemp: "105",
  ChamberTemp: "65",
  X_Axis_Peak_Load: 315.67,
  X_Axis_Yield_Point: 3.24,
  X_Axis_Break_Point: 3.27,
  Layer_Break: 133.37,
  Direct_Thread_Yield: 100.00,
  Heat_Set_Yield: 139.03,
  Izod_Shock_Break: 0.31,
  Min_Bend_Radius: null,
  HDT: null,
  Notes: "As Printed",
  color: "#B89B72",
},

{
  Material: "PET-GF17 305 R",
  MaterialClass: "Polyester",
  Brand: "Polymaker",
  Color: "Light Grey",
  HotendTemp: "305",
  BedTemp: "105",
  ChamberTemp: "61",
  X_Axis_Peak_Load: 236.20,
  X_Axis_Yield_Point: 3.74,
  X_Axis_Break_Point: 3.99,
  Layer_Break: 105.63,
  Direct_Thread_Yield: 90.13,
  Heat_Set_Yield: 126.73,
  Izod_Shock_Break: 0.34,
  Min_Bend_Radius: null,
  HDT: null,
  Notes: "As Printed",
  color: "#B0BEC5",
},

{
  Material: "PLA Pro",
  MaterialClass: "Aliphatic Polyester",
  Brand: "Polymaker",
  Color: "Blue",
  HotendTemp: "220",
  BedTemp: "65",
  ChamberTemp: "",
  X_Axis_Peak_Load: 166.37,
  X_Axis_Yield_Point: 2.22,
  X_Axis_Break_Point: null,
  Layer_Break: 119.60,
  Direct_Thread_Yield: 60.93,
  Heat_Set_Yield: 104.17,
  Izod_Shock_Break: 3.39,
  Min_Bend_Radius: null,
  HDT: null,
  Notes: "As Printed",
  color: "#1976D2",
},

{
  Material: "PLA GO",
  MaterialClass: "Aliphatic Polyester",
  Brand: "BIQU",
  Color: "Black",
  HotendTemp: "220",
  BedTemp: "65",
  ChamberTemp: "",
  X_Axis_Peak_Load: 226.33,
  X_Axis_Yield_Point: 2.88,
  X_Axis_Break_Point: 5.02,
  Layer_Break: 130.63,
  Direct_Thread_Yield: 81.37,
  Heat_Set_Yield: 120.83,
  Izod_Shock_Break: 0.52,
  Min_Bend_Radius: null,
  HDT: null,
  Notes: "As Printed",
  color: "#263238",
},

{
  Material: "PLA Aura Silk",
  MaterialClass: "Aliphatic Polyester",
  Brand: "BIQU",
  Color: "Cheese Yellow",
  HotendTemp: "220",
  BedTemp: "65",
  ChamberTemp: "",
  X_Axis_Peak_Load: 226.43,
  X_Axis_Yield_Point: 3.14,
  X_Axis_Break_Point: 5.61,
  Layer_Break: 102.80,
  Direct_Thread_Yield: 77.50,
  Heat_Set_Yield: 120.30,
  Izod_Shock_Break: 0.34,
  Min_Bend_Radius: null,
  HDT: null,
  Notes: "As Printed",
  color: "#FBC02D",
},

  {
  Test_ID: "Jayo Galaxy PLA",
  Condition: "As_Printed",
  Material: "PLA Galaxy",
  MaterialClass: "Aliphatic Polyester",
  Brand: "Jayo",
  Color: "Starlit Flow",
  HotendTemp: 220,
  BedTemp: 55,
  ChamberTemp: null,
  X_Axis_Peak_Load: 178.9,
  X_Axis_Yield_Point: 2.51,
  X_Axis_Break_Point: null,
  Layer_Break: 203.97,
  Izod_Shock_Break: 0.42,
  Direct_Thread_Yield: 94.80,
  Heat_Set_Yield: 129.10,
  Min_Bend_Radius: null,
  HDT: null,
  Notes: null,
  color: "#7C4DFF",
},

{
  Test_ID: "Polymaker ABS PRO",
  Condition: "As_Printed",
  Material: "ABS",
  MaterialClass: "Styrene",
  Brand: "Polymaker",
  Color: "Black",
  HotendTemp: 280,
  BedTemp: 110,
  ChamberTemp: "70 avg",
  X_Axis_Peak_Load: 143.78,
  X_Axis_Yield_Point: 2.35,
  X_Axis_Break_Point: 4.08,
  Failure_Location: "Radius / Transition",
  Failure_Mode: "Brittle Snap",
  Layer_Break: 88.6,
  Izod_Shock_Break: 1.27,
  Direct_Thread_Yield: 63.42,
  Heat_Set_Yield: 81.16,
  Min_Bend_Radius: null,
  HDT: 113.1,
  Notes: null,
  color: "#263238",
},

{
  Test_ID: "Polymaker ABS MAX",
  Condition: "As_Printed",
  Material: "ABS MAX",
  MaterialClass: "Styrene",
  Brand: "Polymaker",
  Color: "Black",
  HotendTemp: 285,
  BedTemp: 110,
  ChamberTemp: "85 avg",
  X_Axis_Peak_Load: 137.02,
  X_Axis_Yield_Point: 2.3,
  X_Axis_Break_Point: 4.55,
  Layer_Break: 72.86,
  Izod_Shock_Break: 1.31,
  Direct_Thread_Yield: 79.32,
  Heat_Set_Yield: 98.46,
  Min_Bend_Radius: null,
  HDT: 126.2,
  Notes: null,
  color: "#D32F2F",
},
  
{
  Test_ID: "Jayo PLA+ 2.0",
  Condition: "As_Printed",
  Material: "PLA 2.0",
  MaterialClass: "Aliphatic Polyester",
  Brand: "Jayo",
  Color: "Red",
  HotendTemp: 220,
  BedTemp: 65,
  ChamberTemp: null,
  X_Axis_Peak_Load: 213.1,
  X_Axis_Yield_Point: 2.86,
  X_Axis_Break_Point: null,
  Failure_Location: "No Break",
  Failure_Mode: "Deformed - No Break",
  Layer_Break: 204.96,
  Izod_Shock_Break: 1.38,
  Direct_Thread_Yield: 111.56,
  Heat_Set_Yield: 124.8,
  Min_Bend_Radius: null,
  HDT: 55,
  Notes: null,
  color: "#D32F2F",
},

{
  Test_ID: "Jayo Silk PLA+",
  Condition: "As_Printed",
  Material: "PLA+",
  MaterialClass: "Aliphatic Polyester",
  Brand: "Jayo",
  Color: "Light Gold",
  HotendTemp: 220,
  BedTemp: 55,
  ChamberTemp: null,
  X_Axis_Peak_Load: 232.8,
  X_Axis_Yield_Point: 3.01,
  X_Axis_Break_Point: 3.36,
  Failure_Location: "Radius / Transition",
  Failure_Mode: "Brittle Snap",
  Layer_Break: 91.58,
  Izod_Shock_Break: 0.39,
  Direct_Thread_Yield: 77.88,
  Heat_Set_Yield: 130.78,
  Min_Bend_Radius: null,
  HDT: 55,
  Notes: null,
  color: "#FBC02D",
},

{
  Test_ID: "Jayo HS PLA Marble",
  Condition: "As_Printed",
  Material: "PLA Marble",
  MaterialClass: "Aliphatic Polyester",
  Brand: "Jayo",
  Color: "Chestnut Brown Marble",
  HotendTemp: 220,
  BedTemp: 65,
  ChamberTemp: null,
  X_Axis_Peak_Load: 176.22,
  X_Axis_Yield_Point: 2.12,
  X_Axis_Break_Point: null,
  Failure_Location: "No Break",
  Failure_Mode: "Deformed - No Break",
  Layer_Break: 92.74,
  Izod_Shock_Break: 0.61,
  Direct_Thread_Yield: 72.72,
  Heat_Set_Yield: 114.45,
  Min_Bend_Radius: null,
  HDT: 55,
  Notes: null,
  color: "#B0BEC5",
},

{
  Test_ID: "GG3D PETG FLEX",
  Condition: "As_Printed",
  Material: "PETG",
  MaterialClass: "Copolyester",
  Brand: "GreenGate3D",
  Color: "Nautral",
  HotendTemp: 255,
  BedTemp: 80,
  ChamberTemp: null,
  X_Axis_Peak_Load: 183.53,
  X_Axis_Yield_Point: 4.11,
  X_Axis_Break_Point: null,
  Failure_Location: "Gauge Section",
  Failure_Mode: "Deformed - No Break",
  Layer_Break: 105.3,
  Izod_Shock_Break: 0.51,
  Direct_Thread_Yield: 66.87,
  Heat_Set_Yield: 83.07,
  Min_Bend_Radius: null,
  HDT: "NT",
  Notes: null,
  color: "#B0BEC5",
},

{
  Test_ID: "Polymaker HT_PLA_PRO",
  Condition: "As_Printed",
  Material: "HT PLA Pro",
  MaterialClass: "Aliphatic Polyester",
  Brand: "Polymaker",
  Color: "Black",
  HotendTemp: null,
  BedTemp: null,
  ChamberTemp: null,
  X_Axis_Peak_Load: 152.12,
  X_Axis_Yield_Point: 2.83,
  X_Axis_Break_Point: 18.68,
  Failure_Location: "Radius / Transition",
  Failure_Mode: "Tear / Split",
  Layer_Break: 71.38,
  Izod_Shock_Break: 2.67,
  Direct_Thread_Yield: 45.56,
  Heat_Set_Yield: 100,
  Min_Bend_Radius: null,
  HDT: 52.8,
  Notes: null,
  color: "#263238",
},

{
  Test_ID: "Polymaker HT_PLA_PRO",
  Condition: "Annealed_110°C_90min",
  Material: "HT PLA Pro",
  MaterialClass: "Aliphatic Polyester",
  Brand: "Polymaker",
  Color: "Black",
  HotendTemp: null,
  BedTemp: null,
  ChamberTemp: null,
  X_Axis_Peak_Load: 161.05,
  X_Axis_Yield_Point: 2.65,
  X_Axis_Break_Point: 4.27,
  Failure_Location: "Radius / Transition",
  Failure_Mode: "Tear / Split",
  Layer_Break: 45.64,
  Izod_Shock_Break: 2.29,
  Direct_Thread_Yield: 48.46,
  Heat_Set_Yield: 84.22,
  Min_Bend_Radius: null,
  HDT: 111.4,
  Notes: null,
  color: "#263238",
},
  

  // Flexible Materials ##############################################################
  {
    Material: "Fibreheart PEBA-95A",
    MaterialClass: "Thermoplastic Elastomer",
    Brand: "SIRAYA Tech",
    Color: "Black",
    HotendTemp: "255",
    BedTemp: "70",
    ChamberTemp: "NA",
    X_Axis_Peak_Load: null,
    X_Axis_Yield_Point: null,
    X_Axis_Break_Point: null,
    Layer_Break: null,
    Direct_Thread_Yield: null,
    Heat_Set_Yield: null,
    Izod_Shock_Break: null,
    Shore_Hardness: 86.7,
    Layer_Peak: 23.15,
    Flexible_Layer_Break: 23.98,
    Dist_Break: 31.0,
    Bounce: 238,
    Six_mm_Pull: 38.60,
    Sixty_mm_Stretch: 77.80,
    Sixty_mm_Peak: 58.88,
    Flex_Izod_Break: null,
    Notes: "As Printed",
    color: "#E91E63",
  },
  {
    Material: "Fiberheart PEBA-AIR",
    MaterialClass: "Thermoplastic Elastomer",
    Brand: "SIRAYA Tech",
    Color: "Black",
    HotendTemp: "255",
    BedTemp: "60",
    ChamberTemp: "NA",
    X_Axis_Peak_Load: null,
    X_Axis_Yield_Point: null,
    X_Axis_Break_Point: null,
    Layer_Break: null,
    Direct_Thread_Yield: null,
    Heat_Set_Yield: null,
    Izod_Shock_Break: null,
    Shore_Hardness: 85.8,
    Layer_Peak: 29.60,
    Flexible_Layer_Break: 51.29,
    Dist_Break: 53.99,
    Bounce: 193,
    Six_mm_Pull: 30.70,
    Sixty_mm_Stretch: 59.20,
    Sixty_mm_Peak: 59.56,
    Flex_Izod_Break: null,
    Notes: "FLOW .75",
    color: "#26A69A",
  },

// --- UPDATED: TPU Air HR 85A (Siraya Tech) - did NOT break ---
{
  Material: "Roamr TPU Air HR 85A",
  MaterialClass: "Thermoplastic Elastomer",
  Brand: "SIRAYA Tech",
  Color: "Black",
  HotendTemp: "250",
  BedTemp: "35",
  ChamberTemp: "NA",

  // Rigid metrics (null for flex)
  X_Axis_Peak_Load: null,
  X_Axis_Yield_Point: null,
  X_Axis_Break_Point: null,
  Layer_Break: null,
  Direct_Thread_Yield: null,
  Heat_Set_Yield: null,
  Izod_Shock_Break: null,

  // Flex metrics
  Shore_Hardness: 69.50,
  Layer_Peak: 26.60,

  // Did not break -> leave break fields null so it won't plot as a break result
  Flexible_Layer_Break: null,   // was 26.60, now null
  Dist_Break: null,             // NA / no break

  Bounce: 165.40,
  Six_mm_Pull: 9.33,
  Sixty_mm_Stretch: 16.15,
  Sixty_mm_Peak: 47.84,

  Notes: "Flow .78 (Did not break)",
  color: "#FFB300",
},

// --- NEW: TPU Air HR 80A (Siraya Tech) ---
{
  Material: "Roamr TPU Air HR 80A",
  MaterialClass: "Thermoplastic Elastomer",
  Brand: "SIRAYA Tech",
  Color: "Black",
  HotendTemp: "250",
  BedTemp: "35",
  ChamberTemp: "NA",

  // Rigid metrics (null for flex)
  X_Axis_Peak_Load: null,
  X_Axis_Yield_Point: null,
  X_Axis_Break_Point: null,
  Layer_Break: null,
  Direct_Thread_Yield: null,
  Heat_Set_Yield: null,
  Izod_Shock_Break: null,

  // Flex metrics
  Shore_Hardness: 65.20,
  Layer_Peak: 18.90,
  Flexible_Layer_Break: 18.90,   // using Layer Peak as best available “layer break” proxy
  Dist_Break: 44.31,
  Bounce: 178.40,
  Six_mm_Pull: 8.77,
  Sixty_mm_Stretch: 13.10,
  Sixty_mm_Peak: 43.06,

  Notes: "Flow .78",
  color: "#00B0FF",              // distinct light blue
},

// --- NEW: Fiberheart TPU 95A (Siraya Tech) ---
{
  Material: "Fiberheart TPU 95A",
  MaterialClass: "Thermoplastic Elastomer",
  Brand: "SIRAYA Tech",
  Color: "Black",
  HotendTemp: "",
  BedTemp: "",
  ChamberTemp: "",

  // Rigid metrics (null for flex)
  X_Axis_Peak_Load: null,
  X_Axis_Yield_Point: null,
  X_Axis_Break_Point: null,
  Layer_Break: null,
  Direct_Thread_Yield: null,
  Heat_Set_Yield: null,
  Izod_Shock_Break: null,

  // Flex metrics
  Shore_Hardness: 90.90,
  Layer_Peak: 53.70,
  Flexible_Layer_Break: null,     // not provided
  Dist_Break: null,               // NA / did not break
  Bounce: 112.60,
  Six_mm_Pull: 19.30,
  Sixty_mm_Stretch: 37.83,
  Sixty_mm_Peak: 59.38,
  Flex_Izod_Break: 96.00,

  Notes: "",
  color: "#8E24AA",               // distinct purple
},

// --- NEW: Fiberheart TPU GF 95A (Siraya Tech) ---
{
  Material: "Fiberheart TPU GF 67D",
  MaterialClass: "Thermoplastic Elastomer",
  Brand: "SIRAYA Tech",
  Color: "Black",
  HotendTemp: "",
  BedTemp: "",
  ChamberTemp: "",

  // Rigid metrics (null for flex)
  X_Axis_Peak_Load: null,
  X_Axis_Yield_Point: null,
  X_Axis_Break_Point: null,
  Layer_Break: null,
  Direct_Thread_Yield: null,
  Heat_Set_Yield: null,
  Izod_Shock_Break: null,

  // Flex metrics
  Shore_Hardness: 95.50,
  Layer_Peak: 52.10,
  Flexible_Layer_Break: null,     // not provided
  Dist_Break: 12.64,
  Bounce: 120.75,
  Six_mm_Pull: 54.13,
  Sixty_mm_Stretch: 121.20,
  Sixty_mm_Peak: 31.41,
  Flex_Izod_Break: 60.33,

  Notes: "",
  color: "#2E7D32",               // distinct green
},

// --- NEW: Fiberheart TPU 64D (Siraya Tech) ---
{
  Material: "Fiberheart TPU 64D",
  MaterialClass: "Thermoplastic Elastomer",
  Brand: "SIRAYA Tech",
  Color: "Black",
  HotendTemp: "",
  BedTemp: "",
  ChamberTemp: "",

  // Rigid metrics (null for flex)
  X_Axis_Peak_Load: null,
  X_Axis_Yield_Point: null,
  X_Axis_Break_Point: null,
  Layer_Break: null,
  Direct_Thread_Yield: null,
  Heat_Set_Yield: null,
  Izod_Shock_Break: null,

  // Flex metrics
  Shore_Hardness: 96.00,
  Layer_Peak: 57.40,
  Flexible_Layer_Break: null,     // not provided
  Dist_Break: 11.70,
  Bounce: 146.40,
  Six_mm_Pull: 39.77,
  Sixty_mm_Stretch: 74.57,
  Sixty_mm_Peak: 59.64,
  Flex_Izod_Break: 72.67,

  Notes: "",
  color: "#FF6F00",               // distinct amber
},

{
  Material: "TPU 95A??",
  MaterialClass: "Thermoplastic Elastomer",
  Brand: "Jayo",
  Color: "Black",
  HotendTemp: "200",
  BedTemp: "35",
  ChamberTemp: "",

  // Rigid metrics
  X_Axis_Peak_Load: null,
  X_Axis_Yield_Point: null,
  X_Axis_Break_Point: null,
  Layer_Break: null,
  Direct_Thread_Yield: null,
  Heat_Set_Yield: null,
  Izod_Shock_Break: null,
  HDT: null,

  // Flexible metrics
  Shore_Hardness: 93.00,
  Layer_Peak: 42.87,
  Flexible_Layer_Break: 43.23,
  Dist_Break: 44.55,
  Bounce: 108.2,
  Six_mm_Pull: 15.63,
  Sixty_mm_Stretch: 33.23,
  Sixty_mm_Peak: 59.21,
  Flex_Izod_Break: 4.05,

  Notes: "As Printed",
  color: "#616161",
},
];
export default materialTestingData;
